<template>
    <b-form-group>
        <v-select
            class="bg-white"
            v-model="monthModel"
            label="0"
            :clearable="clearable"
            :options="monthOptions"
            @input="handleSelectMonth"
        ></v-select>
    </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { watch } from '@vue/composition-api'
import useSelectMonth from '@/composables/useSelectMonth'
export default {
    components: {
        vSelect
    },
    props: ['clearable', 'storeKey'],
    setup (props, context) {
        const {
            monthModel,
            selectedMonth,
            monthOptions,
            handleSelectMonth
        } = useSelectMonth()
        watch(selectedMonth, (value, oldValue) => {
            monthModel.value = value
        })
        return {
            monthModel,
            selectedMonth,
            monthOptions,
            handleSelectMonth
        }
    }
}
</script>
